import {ExtraReducer, ReducerFromState} from "../../../@types/reducers";

export const getTemplates = (state: ReducerFromState<ExtraReducer>): string[] => state.extra.templates;